/** 常用区号（旧版全量 186 国列表非必要；目前仅 86 可发短信，protocol §3.2） */
export const COUNTRY_CODES = [
  { code: 86, label: '中国大陆 +86' },
  { code: 852, label: '香港 +852' },
  { code: 853, label: '澳门 +853' },
  { code: 886, label: '台湾 +886' },
  { code: 65, label: '新加坡 +65' },
  { code: 60, label: '马来西亚 +60' },
  { code: 81, label: '日本 +81' },
  { code: 82, label: '韩国 +82' },
  { code: 1, label: '美国/加拿大 +1' },
  { code: 44, label: '英国 +44' },
];
